import React, { useEffect, useRef } from "react";
import { Collapse } from "bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../../pages/website/styles/website.css";
import "./Header.css";
import SubmitRequestPopup from "../../components/website/forms/SubmitRequestPopup";
import { websitePaths } from "../../routes/websitePaths";

const Header = () => {
  const { pathname } = useLocation();
  const navbarCollapseRef = useRef<HTMLDivElement | null>(null);

  const getNavLinkClassName = ({ isActive }: { isActive: boolean }) =>
    `nav-link site-nav-link${isActive ? " active" : ""}`;

  const closeMobileMenu = () => {
    const collapseElement = navbarCollapseRef.current;

    if (!collapseElement || !collapseElement.classList.contains("show")) {
      return;
    }

    Collapse.getOrCreateInstance(collapseElement).hide();
  };

  useEffect(() => {
    closeMobileMenu();
  }, [pathname]);

  return (
    <nav className='navbar navbar-expand-lg fixed-top site-header'>
      <div className='container site-header-inner'>
        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#mainNavbar'
          aria-controls='mainNavbar'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        <Link
          className='navbar-brand d-flex align-items-center site-brand'
          to={websitePaths.home}
        >
          <img
            src='dialin24-logo.png'
            alt='Dialin24 Logo'
            className='site-logo'
          />
        </Link>

        <a
          className='button-show-call btn header-call-btn d-flex align-items-center'
          href='tel:+918182833009'
          aria-label='Quick call dial'
        >
          <i className='bi bi-telephone-fill me-2'></i>
        </a>

        <div
          ref={navbarCollapseRef}
          className='collapse navbar-collapse site-nav-wrap'
          id='mainNavbar'
        >
          <ul className='navbar-nav site-nav ms-auto me-lg-3 mb-1 mb-lg-0 align-items-lg-center'>
            <li className='nav-item mx-lg-2'>
              <NavLink
                className={getNavLinkClassName}
                to={websitePaths.home}
                onClick={closeMobileMenu}
              >
                Home
              </NavLink>
            </li>
            <li className='nav-item mx-lg-2'>
              <NavLink
                className={getNavLinkClassName}
                to={websitePaths.projects.all}
                onClick={closeMobileMenu}
              >
                Projects
              </NavLink>
            </li>
            <li className='nav-item mx-lg-2'>
              <NavLink
                className={getNavLinkClassName}
                to={websitePaths.about}
                onClick={closeMobileMenu}
              >
                About Us
              </NavLink>
            </li>
            <li className='nav-item mx-lg-2'>
              <NavLink
                className={getNavLinkClassName}
                to={websitePaths.services}
                onClick={closeMobileMenu}
              >
                Services
              </NavLink>
            </li>
            <li className='nav-item mx-lg-2'>
              <NavLink
                className={getNavLinkClassName}
                to={websitePaths.contact}
                onClick={closeMobileMenu}
              >
                Contact Us
              </NavLink>
            </li>
          </ul>

          <div className='d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center gap-2 mt-3 mt-lg-0 header-actions'>
            <a
              className='btn header-call-btn d-flex align-items-center order-1 order-lg-0'
              href='tel:+918182833009'
            >
              <i className='bi bi-telephone-fill me-2'></i> Call: +91 81828
              33009
            </a>
            <SubmitRequestPopup />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
